
























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";
import KepatuhanJatuhService from "@/services/KepatuhanJatuhService";

import SetupSesiStep from "@/components/KepatuhanJatuh/SetupSesiStep.vue";
import ObservasiPasienStep from "@/components/KepatuhanJatuh/ObservasiPasienStep.vue";
import ChecklistRekapStep from "@/components/KepatuhanJatuh/ChecklistRekapStep.vue";
import KasusRtlStep from "@/components/KepatuhanJatuh/KasusRtlStep.vue";
import PerhitunganStep from "@/components/KepatuhanJatuh/PerhitunganStep.vue";
import RekapPeriodikStep from "@/components/KepatuhanJatuh/RekapPeriodikStep.vue";
import AlasanStep from "@/components/KepatuhanJatuh/AlasanStep.vue";
import RcaStep from "@/components/KepatuhanJatuh/RcaStep.vue";
import TandaTanganStep from "@/components/KepatuhanJatuh/TandaTanganStep.vue";
import DashboardKepatuhanJatuh from "@/components/KepatuhanJatuh/DashboardKepatuhanJatuh.vue";

@Component({
  components: {
    SetupSesiStep,
    ObservasiPasienStep,
    ChecklistRekapStep,
    KasusRtlStep,
    PerhitunganStep,
    RekapPeriodikStep,
    AlasanStep,
    RcaStep,
    TandaTanganStep,
    DashboardKepatuhanJatuh
  }
})
export default class KepatuhanJatuhPage extends Vue {
  tab = 0;
  step = 1;
  printing: number | null = null;
  filter: { tahun: number; bulan: number | null; status: string | null } = {
    tahun: new Date().getFullYear(),
    bulan: null,
    status: null
  };

  get store() {
    return KepatuhanJatuhStore;
  }

  headers = [
    { text: "Nomor", value: "nomor_formulir" },
    { text: "Tanggal", value: "tanggal_observasi" },
    { text: "Unit", value: "unit_nama" },
    { text: "Shift", value: "shift_observasi" },
    { text: "Capaian", value: "capaian_pct" },
    { text: "Kategori", value: "kategori_kepatuhan" },
    { text: "Kej. Jatuh", value: "ada_kejadian_jatuh" },
    { text: "Status", value: "status" },
    { text: "", value: "actions", sortable: false, align: "end" }
  ];

  statusOpts = [
    { text: "Draft", value: "draft" },
    { text: "Submitted", value: "submitted" },
    { text: "Verifikator Signed", value: "verifikator_signed" },
    { text: "Ka Ruangan Signed", value: "ka_ruangan_signed" },
    { text: "Published", value: "published" },
    { text: "Revoked", value: "revoked" }
  ];

  get tahunOpts() {
    const now = new Date().getFullYear();
    return [now, now - 1, now - 2];
  }

  get bulanOpts() {
    return [
      { text: "Januari", value: 1 },
      { text: "Februari", value: 2 },
      { text: "Maret", value: 3 },
      { text: "April", value: 4 },
      { text: "Mei", value: 5 },
      { text: "Juni", value: 6 },
      { text: "Juli", value: 7 },
      { text: "Agustus", value: 8 },
      { text: "September", value: 9 },
      { text: "Oktober", value: 10 },
      { text: "November", value: 11 },
      { text: "Desember", value: 12 }
    ];
  }

  async mounted() {
    await this.refresh();
  }

  async refresh() {
    await this.store.fetchList({
      tahun: this.filter.tahun,
      bulan: this.filter.bulan,
      status: this.filter.status
    });
  }

  startNew() {
    this.store.SET_CURRENT(null);
    this.tab = 1;
    this.step = 1;
  }

  async open(id: number) {
    await this.store.fetchOne(id);
    this.tab = 1;
    this.step = 2;
  }

  async cetak(id: number) {
    this.printing = id;
    try {
      await KepatuhanJatuhService.printPdf(id);
    } catch (e) {
      // pesan sudah ditampilkan ErrorAlert dari service
    } finally {
      this.printing = null;
    }
  }

  onPublished() {
    this.tab = 0;
    this.refresh();
  }

  formatDate(d: string | null | undefined) {
    return d ? new Date(d).toLocaleDateString("id-ID") : "-";
  }

  chipColor(pct: number | undefined) {
    const p = Number(pct || 0);
    if (p >= 100) return "success";
    if (p >= 95) return "light-green";
    if (p >= 80) return "orange";
    return "red";
  }

  kategoriColor(k: string | null | undefined) {
    if (k === "eksellen") return "success";
    if (k === "baik") return "light-green";
    if (k === "cukup") return "orange";
    if (k === "kurang") return "red";
    return "grey";
  }

  labelKategori(k: string | null | undefined) {
    if (!k) return "-";
    return k.charAt(0).toUpperCase() + k.slice(1);
  }

  labelStatus(s: string | null | undefined) {
    if (!s) return "-";
    const map: Record<string, string> = {
      draft: "Draft",
      submitted: "Submitted",
      verifikator_signed: "Verifikator",
      ka_ruangan_signed: "Ka.Ruangan",
      published: "Published",
      revoked: "Revoked"
    };
    return map[s] || s;
  }
}
